import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  SERVICES,
  NOTIFICATION,
} from '../actionTypes';

const fetchServices = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}${query}${sorting}`);
};

export function* getServices(action) {
  try {
    const { data: { entity } } = yield call(fetchServices, action.payload);
    yield put({ type: SERVICES.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: SERVICES.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
